// shared constant for id of main content to ensure skip link is always pointing to the correct element
export const MAIN_CONTENT_ID = "main-content";
